import $ from 'jquery';

export const init = () => {
	const filter = $('.js-filter');

	function filterProjects() {
		const cols = document.querySelectorAll('[data-hook=".js-col"]');
		const input = document.getElementById('news-select').value;

		for (let i = 0; i < cols.length; i++) {
			cols[i].style.display = input == cols[i].querySelector('.js-news-item').dataset.category ? 'flex' : 'none';
		}
	}

	filter.on('change', filterProjects);
};
